/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PairMobileDeviceResponse
 */
export interface PairMobileDeviceResponse {
    /**
     * Long-lived device bearer token. Returned once; the device stores it in the Keychain.
     * @type {string}
     * @memberof PairMobileDeviceResponse
     */
    deviceToken: string;
}

/**
 * Check if a given object implements the PairMobileDeviceResponse interface.
 */
export function instanceOfPairMobileDeviceResponse(value: object): value is PairMobileDeviceResponse {
    if (!('deviceToken' in value) || value['deviceToken'] === undefined) return false;
    return true;
}

export function PairMobileDeviceResponseFromJSON(json: any): PairMobileDeviceResponse {
    return PairMobileDeviceResponseFromJSONTyped(json, false);
}

export function PairMobileDeviceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PairMobileDeviceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'deviceToken': json['deviceToken'],
    };
}

  export function PairMobileDeviceResponseToJSON(json: any): PairMobileDeviceResponse {
      return PairMobileDeviceResponseToJSONTyped(json, false);
  }

  export function PairMobileDeviceResponseToJSONTyped(value?: PairMobileDeviceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deviceToken': value['deviceToken'],
    };
}

